import PropTypes from "prop-types";
import { Box } from "@mui/material";
import useAuth from "hooks/useAuth";
import FavoriteButton from "components/Favorite";
import EditButton from "components/Edit";

/**
 * Card top-right actions:
 * - Favorite for everyone (when favoriteType is set)
 * - Edit for admins (when editType is set)
 * Institution / expert have no favorite API — pass editType only.
 */
export default function CardActionButtons({
  id,
  favoriteType = null,
  editType = null,
  initialIsFavorite = false,
  onFavoriteChange,
  isOnFavoritesPage = false,
  size = "medium",
  parentId = null,
  editTo = null,
  sx = null,
  className = null,
}) {
  const { user } = useAuth();
  const isAdmin = Boolean(user?.is_admin);
  const showFavorite = Boolean(favoriteType);
  const showEdit = isAdmin && Boolean(editType);

  if (!showFavorite && !showEdit) return null;

  return (
    <Box
      className={className}
      onClick={(e) => e.stopPropagation()}
      onKeyDown={(e) => e.stopPropagation()}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.75,
        ...sx,
      }}
    >
      {showFavorite ? (
        <FavoriteButton
          id={id}
          type={favoriteType}
          initialIsFavorite={initialIsFavorite}
          onFavoriteChange={onFavoriteChange}
          isOnFavoritesPage={isOnFavoritesPage}
          size={size}
        />
      ) : null}
      {showEdit ? (
        <EditButton
          id={id}
          type={editType}
          size={size}
          parentId={parentId}
          to={editTo}
        />
      ) : null}
    </Box>
  );
}

CardActionButtons.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  favoriteType: PropTypes.string,
  editType: PropTypes.string,
  initialIsFavorite: PropTypes.bool,
  onFavoriteChange: PropTypes.func,
  isOnFavoritesPage: PropTypes.bool,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  parentId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  editTo: PropTypes.string,
  sx: PropTypes.object,
  className: PropTypes.string,
};
